import { type CountryCode } from '@constants'
import { createMutationHelper } from '@utils/swr'
import { type ECommerceV2Apis } from '../types/apis'

interface OrderPdfUrlResponse {
  data: {
    order_pdf_url: string
  }
}

interface GetOrderPdfUrlArgs {
  country_code: CountryCode
  payment_transaction_id: string
  /** 使用 order.id（資料庫 PK），非 order.order_id（顯示用訂單編號） */
  order_id: number
}

// 使用 createMutationHelper 包裝 GET 請求，因為此請求需要手動觸發（非頁面載入時自動 fetch）
const { useMutation } = createMutationHelper<
  ECommerceV2Apis['get']['orderPdfUrl'],
  OrderPdfUrlResponse,
  GetOrderPdfUrlArgs
>({
  client: 'eCommerceV2',
  key: '/order-pdf-url',
  fetcher: (_, { arg, client }) => {
    return client.get(
      `/${arg.country_code}/payment_transactions/${arg.payment_transaction_id}/orders/${arg.order_id}/pdf`,
    )
  },
})

export const useApiGetOrderPdfUrl = useMutation
